import React, { Component } from 'react';
import Timeline from './timeline';
import EngagSec from './engagementsec';

class CV extends Component {
    state = {  } 
    render() { 
        return (
            <div className="cv-feat" id="cv">
                <div className="divider">
                  <span>Lebenslauf</span>
                </div>
                <Timeline />
                <EngagSec />
            </div>
        );
    }
}
 
export default CV;